/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_NewInputs */



/**
* | output |
* | --- |
* | "New practice conversation" |
*
* @param {Practice_NewInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_new = /** @type {((inputs?: Practice_NewInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_NewInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Nieuw oefengesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvel entretien d'entraînement")
	return /** @type {LocalizedString} */ ("New practice conversation")
});